import { Link, useHistory } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { columnsCsv, options, options1, options2 } from "./user-contents";
import { getRakTransactionReceiptById } from "../../../service/profile-ras-service";
import RaktransactionsPresentational from "./raktransactionsPresentational";
import { getRakTransactionList } from "./utils";
// import { getRakTransactionReceiptById } from "../../../service/profile-ras-service";
import awardImg from "assets/img/icons/common/award-badge.png";
import moment from "moment";
import { transactionData } from "../data.js";
import { updateTransactionStatus } from "../../../service/rak-beneficiary-service";

const RakTransactions = () => {
  const history = useHistory();
  const request = {
    page: 1,
    size: 10,
    beneficiaryName: "",
    receiver: "",
    sender: "",
    applicationId: 1,
    fromDate: "",
    toDate: "",
    searchType: "",
    searchCountry: "",
    searchStatus: "",
    c3REF: "",
    rakRef: "",
    name: "",
    isFilter: true,
    remarks: "",
  };
  const [updateloading, setupdateloading] = useState(false);
  const [filterForm, setFilterForm] = useState(request);
  const [modalShow, setModalShow] = useState(false);
  const [transactionDetailModel, setTransactionDetailModel] = useState(false);
  const [searchBy, setSearchBy] = useState("mobile");
  const [searchByValue, setSearchByValue] = useState("");
  const [filterValues, setFilterValues] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState();
  const [blockStatus, setBlockStatus] = useState(false);
  const [verifiedStatus, setVerifiedStatus] = useState(false);
  const [activeStatus, setActiveStatus] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [noOfFiltersSelected, setNoOfFiltersSelected] = useState(0);
  const [filtersSelected, setFiltersSelected] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedOption1, setSelectedOption1] = useState("");
  const [selectedOption2, setSelectedOption2] = useState("");
  const [rakTransactionList, setRakTransactionList] = useState([]);
  const [allUserListExcel, setallUserProfileListExcel] = useState([]);
  const [type, setType] = useState();
  const [country, setCountry] = useState();
  const [status, setStatus] = useState();
  const [transactionDetails, setTransactionDetails] = useState([]);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });
  const [sizeShow, setSizeShow] = useState();
  const buttonRef = useRef("");
  const [filterLength, setFilterLength] = useState({
    typeLength: 0,
    countryLength: 0,
    statusLength: 0,
  });

  const columns = [
    {
      dataField: "isEligibleForLoyalty",
      text: "Loyalty",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { width: "16px", textAlign: "center" },
      formatter: (cell, row) => {
        return row && row.isEligibleForLoyalty ? (
          <img title="Loyalty" style={{ width: "20px" }} src={awardImg} />
        ) : (
          "-"
        );
      },
    },
    {
      dataField: "",
      text: "",
      sort: false,
      style: { minWidth: "15px", textAlign: "center" },
      formatter: (cell, row) => {
        let states = { ...row };
        return (
          <div
            style={{ color: "black" }}
            // onClick={() => setTransactionDetailModel(true)}
          >
            <i
              style={{ fontSize: 18 }}
              className="fas fa-search"
              onClick={() => {
                setCurrentTransactionId(row.id);
                getRakTransactionById(row.id);
              }}
            />
          </div>
        );
      },
    },
    {
      dataField: "createdDate",
      text: "Date",
      sort: true,
      style: { minWidth: "100px", textAlign: "Left" },
      formatter: (cell, row) => {
        return moment((row && row.createdDate) || null).format(
          "DD-MM-YY HH:mm:ss"
        );
      },
    },

    {
      dataField: "fullName",
      text: "Name",
      sort: false,
      style: { minWidth: "200px", textAlign: "Left" },
    },
    {
      dataField: "mobile",
      text: "Mobile",
      sort: false,
      style: { minWidth: "120px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
    // {
    //   dataField: "beneficiaryName",
    //   text: "Beneficiary",
    //   sort: false,
    //   headerStyle: { textAlign: "center" },
    //   style: { minWidth: "160px", textAlign: "center" },
    // },
    {
      dataField: "country",
      text: "Country",
      sort: false,
      headerStyle: { textAlign: "center" },
      style: { minWidth: "130px", textAlign: "center" },
    },
    {
      dataField: "type",
      text: "Type",
      sort: false,
      headerStyle: { textAlign: "left" },
      style: { minWidth: "150px", textAlign: "left" },
    },
    {
      dataField: "sent",
      text: "Sent(AED)",
      sort: false,
      style: { minWidth: "100px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
    {
      dataField: "c3REF",
      text: "C3 Ref",
      sort: false,
      style: { minWidth: "100px", textAlign: "Left" },
      headerStyle: { textAlign: "center" },
    },
    {
      dataField: "rakref",
      text: "RAK Ref",
      sort: false,
      style: { minWidth: "100px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
    {
      dataField: "referralCode",
      text: "Code",
      sort: false,
      style: { minWidth: "100px", textAlign: "Left" },
      headerStyle: { textAlign: "Left" },
    },
    {
      dataField: "status",
      text: "Status",
      sort: false,
      style: { minWidth: "100px", textAlign: "Left" },
    },
    {
      dataField: "remarks",
      text: "Reversal Remarks",
      sort: false,
      style: { minWidth: "100px", textAlign: "Left" },
    },
  ];

  const rowOnClick = {
    onClick: (e, row, rowIndex) => {
      setCurrentTransactionId(row.id);
      getRakTransactionById(row.id);
    },
  };

  useEffect(() => {
    if (filterForm && filterForm.isFilter) {
      getAllRakTransactions(filterForm);
    }
  }, [filterForm]);

  const getAllRakTransactions = (request) => {
    request["searchStatus"] =
      request.searchStatus.length == 0 ? "" : request.searchStatus;
    request["searchType"] =
      request.searchType.length == 0 ? "" : request.searchType;
    request["searchCountry"] =
      request.searchCountry.length == 0 ? "" : request.searchCountry;
    request.size = sizeShow || 10;

    setDataLoading(true);
    getRakTransactionList(request)
      .then((res) => {
        setDataLoading(false);
        if (res && res.data && res.data.moneyTransferTransactions.length > 0) {
          setRakTransactionList(res.data.moneyTransferTransactions);
        } else {
          setRakTransactionList([]);
        }
        setPagination({
          ...pagination,
          pageSize: sizeShow || 10,
          total: res.data.totalCount,
          current: request.page,
        });
      })
      .catch((err) => {
        setDataLoading(false);
        setRakTransactionList();
      });
  };
  const [currentTransactionId, setCurrentTransactionId] = useState();

  const getRakTransactionById = (id) => {
    getRakTransactionReceiptById(id)
      .then(async (res) => {
        await setTransactionDetails(res.data);
        await setTimeout(() => {}, 0);
        await setTransactionDetailModel(true);
      })
      .catch((err) => {
        // message.error("Something went wrong");
        setTransactionDetailModel(false);
        setCurrentTransactionId("");
        setTransactionDetails("");
      });
  };

  const updateStatusClicked = () => {
    setupdateloading(true);
    updateTransactionStatus(currentTransactionId)
      .then(async (res) => {
        setupdateloading(false);
        await setTransactionDetailModel(false);
        await getRakTransactionById(currentTransactionId);
      })
      .catch((err) => {
        setupdateloading(false);
        console.log(err);
        // message.error("something went wrong");
      });
  };

  const resetFilter = () => {
    setSearchBy("mobile");
    // setSearchByValue('');
    setFiltersSelected(false);
    setRakTransactionList([]);
    setallUserProfileListExcel([]);
    setFromDate(null);
    setToDate(null);
    setStatus("");
    setCountry("");
    setType("");
    setSelectedOption("");
    setSelectedOption1("");
    setSelectedOption2("");
    setFilterValues(false);
    setNoOfFiltersSelected(0);
    setFilterLength({ typeLength: 0, countryLength: 0, statusLength: 0 });
    setSearchByValue("");
    setFilterForm(request);
  };

  const handleFIlter = () => {
    let request = {};
    if (searchBy === "name") {
      request = {
        ...filterForm,
        name: searchByValue.trim(),
        sender: "",
        beneficiaryName: "",
        country: "",
        type: "",
        sent: "",
        c3REF: "",
        rakref: "",
        status: "",
        referralCode: "",
      };
    } else if (searchBy === "mobile") {
      request = {
        ...filterForm,
        sender: searchByValue.trim(),
        fullName: "",

        date: "",
        beneficiaryName: "",
        country: "",
        type: "",
        sent: "",
        c3REF: "",
        rakref: "",
        status: "",
        referralCode: "",
      };
    } else if (searchBy === "date") {
      request = {
        ...filterForm,
        date: searchByValue.trim(),
        fullName: "",
        sender: "",
        beneficiaryName: "",
        country: "",
        type: "",
        sent: "",
        c3REF: "",
        rakref: "",
        status: "",
        referralCode: "",
      };
    } else if (searchBy === "beneficiary") {
      request = {
        ...filterForm,
        beneficiaryName: searchByValue.trim(),
        fullName: "",
        sender: "",
        country: "",
        type: "",
        sent: "",
        c3REF: "",
        rakref: "",
        status: "",
        referralCode: "",
      };
    } else if (searchBy === "Country") {
      request = {
        ...filterForm,
        searchCountry: searchByValue.trim(),
        fullName: "",
        date: "",
        sender: "",
        beneficiaryName: "",
        type: "",
        sent: "",
        c3REF: "",
        rakref: "",
        status: "",
        referralCode: "",
      };
    } else if (searchBy === "type") {
      request = {
        ...filterForm,
        type: searchByValue.trim(),
        fullName: "",
        sender: "",
        beneficiaryName: "",
        country: "",
        sent: "",
        c3REF: "",
        rakref: "",
        status: "",
        date: "",
        referralCode: "",
      };
    } else if (searchBy === "sent_aed") {
      request = {
        ...filterForm,
        sent: searchByValue.trim(),
        fullName: "",
        sender: "",
        beneficiaryName: "",
        country: "",
        c3REF: "",
        rakref: "",
        status: "",
        date: "",
        type: "",
        referralCode: "",
      };
    } else if (searchBy === "c3ref") {
      request = {
        ...filterForm,
        c3REF: searchByValue.trim(),
        fullName: "",
        sender: "",
        beneficiaryName: "",
        country: "",
        rakref: "",
        status: "",
        date: "",
        type: "",
        sent: "",
        referralCode: "",
      };
    } else if (searchBy === "rakref") {
      request = {
        ...filterForm,
        rakref: searchByValue.trim(),
        fullName: "",
        sender: "",
        beneficiaryName: "",
        type: "",
        sent: "",
        c3REF: "",
        status: "",
        country: "",
        date: "",
        referralCode: "",
      };
    } else if (searchBy === "status") {
      request = {
        ...filterForm,
        searchStatus: searchByValue,
        fullName: "",
        sender: "",
        beneficiaryName: "",
        type: "",
        sent: "",
        c3REF: "",
        country: "",
        date: "",
        referralCode: "",
        rakref: "",
      };
    } else if (searchBy === "Code") {
      request = {
        ...filterForm,
        referralCode: searchByValue,
        fullName: "",
        sender: "",
        beneficiaryName: "",
        type: "",
        sent: "",
        c3REF: "",
        country: "",
        date: "",
        rakref: "",
      };
    } else if (searchBy === "remarks") {
      request = {
        ...filterForm,
        remarks: searchByValue,
        referralCode: "",
        fullName: "",
        sender: "",
        beneficiaryName: "",
        type: "",
        sent: "",
        c3REF: "",
        country: "",
        date: "",
        rakref: "",
      };
    }
    if (
      filterForm &&
      filterForm.searchCountry &&
      filterForm.searchCountry.length > 0
    ) {
      let a = "";
      if (typeof filterForm.searchCountry === "object") {
        filterForm &&
          filterForm.searchCountry &&
          filterForm.searchCountry.forEach((v, i) => {
            a =
              a +
              v.value +
              (i + 1 < filterForm.searchCountry.length ? "," : "");
          });
        request.searchCountry = a || "";
        request.countryLength = filterForm.searchCountry.length;
      }
    } else {
      request.searchCountry = filterForm.searchCountry || "";
      request.countryLength = "";
    }
    if (
      filterForm &&
      filterForm.searchStatus &&
      filterForm.searchStatus.length > 0
    ) {
      let a = "";
      if (typeof filterForm.searchStatus === "object") {
        filterForm &&
          filterForm.searchStatus &&
          filterForm.searchStatus.forEach((v, i) => {
            a =
              a + v.value + (i + 1 < filterForm.searchStatus.length ? "," : "");
          });
        request.searchStatus = a || "";
        request.statusLength = filterForm.searchStatus.length;
      }
    } else {
      request.searchStatus = filterForm.searchStatus || "";
      request.statusLength = "";
    }

    if (
      filterForm &&
      filterForm.searchType &&
      filterForm.searchType.length > 0
    ) {
      let a = "";
      if (typeof filterForm.searchType === "object") {
        filterForm &&
          filterForm.searchType &&
          filterForm.searchType.forEach((v, i) => {
            a = a + v.value + (i + 1 < filterForm.searchType.length ? "," : "");
          });
        request.searchType = a || "";
        request.typeLength = filterForm.searchType.length;
      }
    } else {
      request.searchType = filterForm.searchType || "";
    }
    request.fromDate =
      (fromDate && moment(fromDate).format("YYYY-MM-DD")) || null;
    request.toDate = (toDate && moment(toDate).format("YYYY-MM-DD")) || null;
    request.searchFilter = "";
    let a = "";
    if (selectedOption.length > 0) {
      selectedOption.forEach((v, i) => {
        a = a + v.value + (i + 1 < selectedOption.length ? "," : "");
      });
    }
    request.page = 1;
    request.searchFilter = a; // TODO - NEED TO REMOVE
    request.isFilter = true;

    setFilterForm(request);
  };

  let searchByValuePlaceholder = "";
  if (searchBy === "name") {
    searchByValuePlaceholder = "Amit Pandit";
  } else if (searchBy === "mobile") {
    searchByValuePlaceholder = "971xxxxxxxxx";
  } else if (searchBy === "beneficiary") {
    searchByValuePlaceholder = "Crosaxxx bxxxx";
  } else if (searchBy === "Country") {
    searchByValuePlaceholder = "Unixxx sxxxx";
  } else if (searchBy === "c3ref") {
    searchByValuePlaceholder = "Unixxx sxxxx";
  } else if (searchBy === "rakref") {
    searchByValuePlaceholder = "Unixxx sxxxx";
  } else if (searchBy === "status") {
    searchByValuePlaceholder = "Unixxx sxxxx";
  } else if (searchBy === "Code") {
    searchByValuePlaceholder = "AB1234";
  } else if (searchBy === "remarks") {
    searchByValuePlaceholder = "Unixxx sxxxx";
  } else {
    searchByValuePlaceholder = "1234567890";
  }

  const onExcelClciked = (filterForm) => {
    let request = filterForm;
    request.page = 1;
    request.size = "";
    getRakTransactionList(request)
      .then((res) => {
        if (res && res.data && res.data.moneyTransferTransactions.length > 0) {
          let data = res.data.moneyTransferTransactions.map((element) => {
            if (element.createdDate) {
              element.createdDate = moment(element.createdDate).format(
                "DD-MM-YYYY"
              );
            }
            return element;
          });
          setallUserProfileListExcel(() => data);
          buttonRef.current.click();
        } else {
          setallUserProfileListExcel([]);
        }
      })
      .catch((err) => {
        setallUserProfileListExcel([]);
      });
  };

  return (
    <RaktransactionsPresentational
      searchBy={searchBy}
      setFiltersSelected={setFiltersSelected}
      rowOnClick={rowOnClick}
      updateStatusClicked={updateStatusClicked}
      updateloading={updateloading}
      setSearchByValue={setSearchByValue}
      setSearchBy={setSearchBy}
      searchByValuePlaceholder={searchByValuePlaceholder}
      searchByValue={searchByValue}
      fromDate={fromDate}
      setFromDate={setFromDate}
      toDate={toDate}
      transactionDetails={transactionDetails}
      setCurrentTransactionId={setCurrentTransactionId}
      setToDate={setToDate}
      setModalShow={setModalShow}
      filtersSelected={filtersSelected}
      noOfFiltersSelected={noOfFiltersSelected}
      resetFilter={resetFilter}
      handleFIlter={handleFIlter}
      filterValues={filterValues}
      transactionData={rakTransactionList}
      dataLoading={dataLoading}
      buttonRef={buttonRef}
      filterForm={filterForm}
      onExcelClciked={onExcelClciked}
      allUserListExcel={allUserListExcel}
      columns={columns}
      columnsCsv={columnsCsv}
      pagination={pagination}
      setFilterForm={setFilterForm}
      setSizeShow={setSizeShow}
      modalShow={modalShow}
      options={options}
      options1={options1}
      options2={options2}
      transactionDetailModel={transactionDetailModel}
      setTransactionDetailModel={setTransactionDetailModel}
      type={type}
      country={country}
      status={status}
      setType={setType}
      setCountry={setCountry}
      setStatus={setStatus}
      setNoOfFiltersSelected={setNoOfFiltersSelected}
      filterLength={filterLength}
      setFilterLength={setFilterLength}
    />
  );
};

export default RakTransactions;
